export default ({ _this }, varname) => ({
  isDragging: false,
  isDropped: false,
  files: [],

  onDrop(e) {
    this.handleDropping(Array.from(e.dataTransfer.files))
  },

  handleDropping(droppedFiles) {
    this.isDropped = true
    this.isDragging = false

    droppedFiles.forEach(file => {
      const id = Date.now() + Math.random()
      const fileEntry = {
        id,
        name: file.name,
        progress: 0,
        url: null
      }

      this.files.push(fileEntry)

      _this.upload(
        varname,
        file,
        (uploadedUrl) => {
          // Upload completed
          fileEntry.url = uploadedUrl // Set the uploaded URL for display
          this.files = this.files.filter(f => f.id !== fileEntry.id)
        },
        () => {
          // An error occurred while uploading
          console.error('Upload error')
          this.files = this.files.filter(f => f.id !== fileEntry.id)
        },
        (event) => {
          // Progress update
          fileEntry.progress = Math.round((event.loaded / event.total) * 100)
        }
      )
    })

    this.isDropped = false
  },
  onDragenter() {
    this.isDragging = true
  },
  onDragleave() {
    this.isDragging = false
  },
  onDragover() {
    this.isDragging = true
  },
  onFileSelect(event) {
    this.handleDropping(Array.from(event.target.files))
  }
})
